export const userSlice = (set, get) => ({
    userName: '',
    role: 'client',
    headers: {},
    wallet: 0,
    walletRevision: 0,
    lastMovement: {},
    userSyncStatus: 'pending',
    userSyncError: '',
    findedProducts: [],
    mobileDevice: false,
    updateUserName: (currentUserName) => set((state) => ({ ...state, userName: currentUserName })),
    updateHeaders: (currentToken) => set((state) => (
        {
            ...state,
            headers:
                currentToken ? { Authorization: `Bearer ${currentToken}`, 'Content-Type': 'application/json' } : {}
        }
    )),
    updateWallet: (newWallet) => set((state) => ({
        ...state,
        wallet: newWallet,
        walletRevision: state.walletRevision + 1
    })),
    updateLastMovement: (newLastMovemet) => set((state) => ({ ...state, lastMovement: newLastMovemet })),
    getWallet: () => get().wallet,
    getLastMovement: () => get().lastMovement,
    setFindedProducts: (products) => set((state) => ({ ...state, findedProducts: products })),
    getFindedProducts: () => get().findedProducts,
    setMobileDevice: (newValue) => set((state) => ({ ...state, mobileDevice: newValue })),
    getMobileDevice: () => get().mobileDevice,
    beginUserSync: () => set((state) => ({ ...state, userSyncStatus: 'loading', userSyncError: '' })),
    finishUserSync: () => set((state) => ({ ...state, userSyncStatus: 'ready', userSyncError: '' })),
    failUserSync: (message) => set((state) => ({ ...state, userSyncStatus: 'error', userSyncError: message })),
    applyServerUser: ({ name, wallet, role }) => set((state) => ({
        ...state,
        ...(typeof name === 'string' && name ? { userName: name } : {}),
        ...(typeof wallet === 'number' && Number.isFinite(wallet) ? { wallet } : {}),
        ...(['client', 'distributor', 'gold_partner', 'admin', 'superadmin'].includes(role) ? { role } : {}),
        userSyncStatus: 'ready',
        userSyncError: ''
    })),
    startAuthenticatedSession: (token, name, role) => set((state) => ({
        ...state,
        userName: name || '',
        role: ['client', 'distributor', 'gold_partner', 'admin', 'superadmin'].includes(role) ? role : 'client',
        headers: token ? { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } : {},
        wallet: 0,
        lastMovement: {},
        findedProducts: [],
        userSyncStatus: token ? 'loading' : 'ready',
        userSyncError: ''
    })),
    clearPrivateUser: () => set((state) => ({
        ...state,
        userName: '',
        role: 'client',
        headers: {},
        wallet: 0,
        lastMovement: {},
        findedProducts: [],
        userSyncStatus: 'ready',
        userSyncError: ''
    }))
});
